module.exports = __webpack_public_path__ + "static/media/css3.ba229688.jpg";